import { RxDocument } from 'rxdb'
import { Attr, BaseSchema, ModelSchema, PARAMS_TO_QUERY_STRING } from './helpers'
import { Store } from './services/Store'
import { UrlSchema } from './UrlSchema'

@ModelSchema({
  name: 'user',
  description: 'A User is anyone with a login',
  version: 0,
  sync: false,
  associations: () => [
    { type: 'hasOne', model: UrlSchema, key: 'url', foreignKey: 'username' },
  ],
  lifecycle: {
    async fetch(store, params) {
      const { selector, modifier } = params
      if (selector.username) {
        const { response } = await store.API.GET(`/users/${selector.username}`, modifier)
        return response.user
      }
    },

    async fetchQuery(store, params) {
      const { response } = await store.API.GET(`/users?${PARAMS_TO_QUERY_STRING(params)}`)
      return response.users
    },
  },
})
export class UserSchema extends BaseSchema {
  static async setSession(store: Store, user: RxDocument<UserSchema>) {
    if (user.id) {
      const url = await user.populate('username').catch(() => null)
      store.session = { user, url }
      store.setSetting('active_user', user.username)
    }
  }

  static getNameString(u: UserSchema) { return u.first_name && u.last_name ? `${u.first_name} ${u.last_name}` : u.email }

  @Attr({ type: 'string', format: 'email', required: true }) email: string
  @Attr({ type: 'string' }) first_name: string
  @Attr({ type: 'string' }) last_name: string
  @Attr({ type: 'boolean' }) enabled?: string
  @Attr({ type: ['string','null'], format: 'date-time' }) last_login_at?: string

  username: string
}
